import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {Country} from '../../models/lookups/country';
import {Query} from '../../models/query/query';
import {WebMethodResult} from '../../models/web-method-result';
import {AppModulePath} from '../../models/app-module-path';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class CountryService extends BaseService {
  private listUrl = '/api/countries/list';
  private postUrl = '/api/countries/save';
  private deleteUrl = '/api/countries/delete/';
  private nbsImportUrl = '/api/countries/nbs_import';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<Country[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Country[]>(url, AppModulePath.COUNTRY).pipe(
      map(res => res.map(obj => new Country(obj))),
      catchError(this.handleError));
  }

  save(country: Country): Observable<Country> {
    return this.post<Country>(this.postUrl, AppModulePath.COUNTRY, country).pipe(
      map(res => new Country(res)),
      catchError(this.handleError));
  }

  delete(id: number): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.COUNTRY).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  nbsImport(onFinish: () => void) {
    return this.post(this.nbsImportUrl, AppModulePath.COUNTRY, '')
      .subscribe(onFinish, this.handleError);
  }
}
